var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-template',{ref:"table",attrs:{"loading":_vm.loading,"total":_vm.total,"current-page":_vm.page,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"has-add":""},on:{"onChangePage":_vm.changeCurrentPage,"onAdd":function($event){return _vm.$router.push('./add')},"onHandle":_vm.tableHandle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }